import React from 'react';
import SettingsPage from '@/pageComponents/Settings';

const Subscription = () => <SettingsPage pathname="/settings/subscription" />;

export default Subscription;
